import React from 'react';

import { Nullable } from '@clearverify/types';

import { usePermissiblePurposeQuery } from 'src/api';

type PermissiblePurposeHookParams = {
  id: Nullable<string>;
  skip?: boolean;
};

export const usePermissiblePurpose = (params: PermissiblePurposeHookParams) => {
  const { data, loading } = usePermissiblePurposeQuery({
    variables: { filter: { id: String(params.id) } },
    skip: params.skip || !params.id,
  });

  const permissiblePurpose = React.useMemo(
    () => data?.permissiblePurpose,
    [data?.permissiblePurpose],
  );

  return { permissiblePurpose, loading };
};
